export default function initAccordeonMenu() {
  const $items = document.querySelectorAll('.sup-footer-col');

  if (!$items) {
    return;
  }

  Array.from($items).forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('toggle');
    });
  });
}
